import React from "react"
import _ from "lodash"
import { InputText } from "primereact/inputtext"

type PRKeyFilter = RegExp
  | 'pint'      //Positive integers
  | 'int'       //Integers
  | 'pnum'      //Positive numbers
  | 'num'       //Numbers
  | 'hex'       //Hexadecimal
  | 'email'     //Email
  | 'alpha'     //Alphabetic
  | 'alphanum'  //Alphanumeric

const TextEdit = (props: {rowData: [], field: string, persist: Function, className: string, keyfilter?: PRKeyFilter, disabled?: boolean}) => {
  let disabled = (props.disabled ||
                  (props.rowData['systeminput'] === "systemImmutable" && !_.includes(props.className, "system-immutable-editable")) ||
                  (props.rowData['systeminput'] === "system" && _.includes(props.className, "system-disabled")))

  const persist = (value, field, rowData, e) => {
    if(field === "code") value = _.replace(value, /\*/g, "")

    props.persist(value, field, rowData, e)
  }
  return(
    <InputText
      type='text'
      disabled={disabled}
      className={props.className}
      defaultValue={_.get(props.rowData, props.field)}
      keyfilter={props.keyfilter}
      onKeyDown={e => {
        switch(e.key) {
          case "Enter":
            persist((e.target as HTMLInputElement).value, props.field, props.rowData, e)
            break
          case "Tab":
            persist((e.target as HTMLInputElement).value, props.field, props.rowData, e)
            break
        }
      }}
      onBlur={e => persist((e.target as HTMLInputElement).value, props.field, props.rowData, e)}/>
  )
}

export default TextEdit